function importAll(r) {
    let images = {};
    r.keys().map((item, index) => {

        let name = item.replace('./', '');
        name = name.substr(0, name.indexOf("."));

        let pos1 = name.indexOf("_");
        let pos2 = name.indexOf("_", pos1 + 1);
        let pos3 = name.indexOf("_", pos2 + 1);
        const id = name.substr(pos1 + 1, pos2 - pos1 - 1);
        const type = name.substr(pos2 + 1, pos3 - pos2 - 1);
        name = name.substr(0, name.indexOf("_"));

        if (!images[name]) images[name] = {};
        if (!images[name][`_${id}`]) images[name][`_${id}`] = {};
        if (type === "before") {
            images[name][`_${id}`] = {
                ...images[name][`_${id}`], before: r(item)
            }
        }
        else {
            images[name][`_${id}`] = {
                ...images[name][`_${id}`], after: r(item)
            }
        }
    });

    return images;
}

export default {
    "plasticka-chirurgie": importAll(require.context('./plasticka-chirurgie', false, /\.(png|jpe?g|svg)$/)),
    "laserova-estetika": importAll(require.context('./laserova-estetika', false, /\.(png|jpe?g|svg)$/)),
    "obecna-a-zilni-chirurgie": importAll(require.context('./obecna-a-zilni-chirurgie', false, /\.(png|jpe?g|svg)$/)),
    "dermatologie": importAll(require.context('./dermatologie', false, /\.(png|jpe?g|svg)$/)),
    "orl-usni-nosni-krcni": importAll(require.context('./ostatni', false, /\.(png|jpe?g|svg)$/)),
    "ostatni": importAll(require.context('./ostatni', false, /\.(png|jpe?g|svg)$/)),
}


// WEBPACK FOOTER //
// ./src/assets/img/llc/surgery/procedures_tn/index.js